export default {
    topics: [
        {
            title: ' PushEvent ',
            href: 'sm-rtEvent-PushEvent.html',
            attributes: { 'data-id': 'sm-rtEvent-PushEvent' },
            menu: { hasChildren: false },
            tocID: 'sm-rtEvent-PushEvent-d66e3759',
            topics: [],
        },
        {
            title: ' PushEvents ',
            href: 'sm-rtEvent-PushEvents.html',
            attributes: { 'data-id': 'sm-rtEvent-PushEvents' },
            menu: { hasChildren: false },
            tocID: 'sm-rtEvent-PushEvents-d66e3767',
            topics: [],
        },
    ],
};

